import { render, staticRenderFns } from "./OfficeRangeTable.vue?vue&type=template&id=8b85c36e&"
import script from "./OfficeRangeTable.vue?vue&type=script&lang=ts&"
export * from "./OfficeRangeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports